import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

import * as routes from "../../../router/routes";
import SVG from "../../SVG";
import { Popover, PopoverBody } from "../../simple";
import Api from "../../../api";
import { headerPopoverOptions } from "../../../helpers/popoverOptions";

export default function Profile(props) {
  const { user, isOpen, setState } = props;
  const currentSubscription = user.company && user.company.currentSubscription;

  return (
    <div className="profile">
      <div
        id="profilePopover"
        role="button"
        tabIndex="0"
        onClick={() => setState(!isOpen)}
        className="profile-container"
      >
        {/* <div className="profile-image"> */}
        {/*  {user?.profilePhoto ? ( */}
        {/*    <img className="avatar" src={user.profilePhoto} alt="avatar" /> */}
        {/*  ) : ( */}
        {/*    <SVG.Client /> */}
        {/*  )} */}
        {/* </div> */}
        <div className="profile-details">
          <div className="name">{user.name || ""}</div>
          <SVG.Arrow2
            fill="#063AC9"
            className={`${isOpen ? "rotate-180" : ""}`}
          />
          {/* <span */}
          {/*  className={`profile-subscription ${ */}
          {/*    currentSubscription === "Freemium" ? "green" : "" */}
          {/*  } ${currentSubscription === "Premium" ? "premium" : ""}`} */}
          {/* > */}
          {/*  {currentSubscription || ""} */}
          {/* </span> */}
        </div>
      </div>
      <Popover
        trigger="legacy"
        isOpen={isOpen}
        target="profilePopover"
        toggle={() => setState(!isOpen)}
        {...headerPopoverOptions}
        modifiers={{ flip: { enabled: false } }}
        popperClassName="profile-popover"
        flip={false}
      >
        <PopoverBody>
          <div
            className={`user-plan-description ${
              currentSubscription === "Premium" ? "premium" : ""
            } ${currentSubscription === "Freemium" ? "freemium" : ""}`}
          >
            <div className="plan-container">
              <div className="plan-title">
                Plan <br />
                <span className="plan-name">{currentSubscription}</span>
              </div>
            </div>
          </div>
          <div className="delimiter-horizon"></div>
          <NavLink to={routes.accountProfile} className="profile-popover-link">
            <SVG.Client className="link-icon account" />
            Account
          </NavLink>
          <NavLink to={routes.apiAccess} className="profile-popover-link">
            <SVG.Cog className="link-icon api" />
            Api
          </NavLink>
          <div className="delimiter-horizon"></div>
          <NavLink
            onClick={() => Api.auth.logOut()}
            to={routes.signIn}
            className="profile-popover-link logout"
          >
            <SVG.Arrow className="link-icon " />
            Log out
          </NavLink>
        </PopoverBody>
      </Popover>
    </div>
  );
}

Profile.propTypes = {
  setState: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  user: PropTypes.shape({
    name: PropTypes.string,
    plan: PropTypes.string,
    company: PropTypes.shape({
      currentSubscription: PropTypes.string
    }),
    role: PropTypes.string,
    profilePhoto: PropTypes.string
  }).isRequired
};
